import React, { type ReactElement, type ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function Wrapper({ children, className }: Props): ReactElement {
  return (
    <div className={classNames('h-full w-full', className)}>{children}</div>
  );
}
